// One source of truth for every page's <title>, description and sitemap entry.
// Read by the <Seo> component (client navigation) and by scripts/prerender.mjs
// (the static HTML that browsers, search engines and AI crawlers receive).

export interface RouteMeta {
  path: string
  title: string
  description: string
  /** Sitemap hints; omit `sitemap` to keep a page out of the sitemap. */
  sitemap?: { priority: number; changefreq: 'weekly' | 'monthly' | 'yearly' }
  noindex?: boolean
}

export const routes: RouteMeta[] = [
  {
    path: '/',
    title: 'GIA Longevity US | Making Living Longer Mean Living Better',
    description:
      'The U.S. Chapter of the Global Initiative on Ageing and Longevity, a 501(c)(3) nonprofit convening leaders across sectors so longer lives become better lives.',
    sitemap: { priority: 1, changefreq: 'weekly' },
  },
  {
    path: '/privacy',
    title: 'Privacy Policy | GIA Longevity US',
    description:
      'How GIA Longevity US collects, uses, shares and protects your information, including donor privacy, cookies and your privacy choices.',
    sitemap: { priority: 0.3, changefreq: 'yearly' },
  },
  {
    path: '/terms',
    title: 'Terms of Use | GIA Longevity US',
    description:
      'The terms that govern your use of gialongevity.us and the digital services of GIA Longevity US.',
    sitemap: { priority: 0.3, changefreq: 'yearly' },
  },
  {
    path: '/accessibility',
    title: 'Accessibility Statement | GIA Longevity US',
    description:
      'Our commitment to WCAG 2.1 AA, the on-page accessibility tools available on this site, and how to request content in an accessible format.',
    sitemap: { priority: 0.4, changefreq: 'yearly' },
  },
]

export const notFoundRoute: RouteMeta = {
  path: '/404',
  title: 'Page not found | GIA Longevity US',
  description: 'The page you were looking for does not exist.',
  noindex: true,
}

export function routeMeta(path: string): RouteMeta {
  return routes.find((r) => r.path === path) ?? notFoundRoute
}
